/**
 * Component providing a back button.
 */
import React, { Component } from 'react';
import { Button } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';

class BackButton extends Component {
    
  goBack() {
    if (this.props.backLink) {
      this.props.history.push(`/${this.props.backLink}`);
    } else {
      this.props.history.goBack();
    }
  }
        
  render() {
    let backToContext = 'Back';
    if (this.props.name != null && this.props.name !== '' && this.props.name !== 'Back') { 
      backToContext = 'Back to ' + this.props.name;
    }

    return (
        <Button color="primary" variant="outlined" size="small" 
          onClick={() => {this.goBack();}}>
          <ArrowBack fontSize="inherit" style={{marginRight:'5px'}}/> {backToContext}
        </Button>
    );
  }
}
  
export default BackButton;
